import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';

import { ModalService } from '../../../services/common/modal.service';
import { NotyService } from '../../../services/common/noty.service';
import { NewsletterMailinglistService } from '../../../services/newsletters/newsletter-mailinglist.service';

@Component({
  selector: 'app-contact-newsletter-mailinglists',
  templateUrl: './contact-newsletter-mailinglists.component.html',
  styleUrls: ['./contact-newsletter-mailinglists.component.scss'],
})
export class ContactNewsletterMailinglistsComponent implements OnInit, OnChanges {
  /**
   * Contact Id for tags
   */
  @Input() contactId: number;

  /**
   * Form options for adding to newsletter mailing list
   * @type {any}
   */
  formOptions: any = {
    newsletter_mailinglists: [],
  };

  /**
   * New Newsletter Mailing List id
   * @type {string | null}
   */
  newNewsletterMailginlistId: number | null;

  /**
   * List of tags
   * @type {Array<any>}
   */
  newsletterMailinglists: Array<any> = [];

  /**
   * Inidcates if list is loading
   * @type {boolean}
   */
  loadingNewsletterMailinglists: boolean = true;

  /**
   * Indicates if new newsletter mailing list form is to be shown
   * @type {boolean}
   */
  showNewNewsletterMailinglistForm: boolean = false;

  /**
   * Inject dependent services
   * @param {ModalService}                 private modalService Display confirm modals
   * @param {NotyService}                  private notyService  Service for notifications
   * @param {NewsletterMailinglistService} private newsletterMailinglistService   Service for Newsletter Mailing List Resource
   */
  constructor(private modalService: ModalService, private notyService: NotyService, private newsletterMailinglistService: NewsletterMailinglistService) {
    this.newsletterMailinglistService.index().then((response_json) => (this.formOptions.newsletter_mailinglists = response_json));
  }

  // Component lifecycle methods
  ngOnInit() {}

  /**
   * Called when component variables change
   * @param {SimpleChanges} changes Object with variables which have changed
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.contactId && changes.contactId.currentValue) this.loadNewsletterMailinglists();
  }

  // Component methods

  /**
   * Load newsletter mailing lists
   */
  loadNewsletterMailinglists() {
    this.loadingNewsletterMailinglists = true;
    this.newsletterMailinglistService.index({ contact_id: this.contactId }).then((response_json) => {
      this.newsletterMailinglists = response_json;
      this.loadingNewsletterMailinglists = false;
    });
  }

  /**
   * Add to newsletter mailing list
   */
  addToNewsletterMailinglist() {
    if (this.newNewsletterMailginlistId)
      this.newsletterMailinglistService
        .addContact(this.newNewsletterMailginlistId, this.contactId)
        .then((response_json) => {
          if (response_json.success) {
            this.notyService.notify(response_json.text || 'Added to Newsletter Mailing List', 'success', 5000, 'topRight');
            this.newNewsletterMailginlistId = null;
            this.loadNewsletterMailinglists();
            this.showNewNewsletterMailinglistForm = false;
          } else this.notyService.notify(response_json.text || response_json.result || 'Error adding to newsletter mailing list', 'error', 5000, 'topRight');
        })
        .catch(() => {
          this.notyService.notify('Error adding to newsletter mailing list', 'error', 5000, 'topRight');
        });
    else this.notyService.notify('A newsletter mailing list needs to be selected', 'warning', 5000, 'topRight');
  }

  /**
   * Remove from newsletter mailing list
   * @param {number} newsletterMailinglistId id of newsletter mailing list to remove from
   * @param {number} index                   position of newsletter mailing list in array
   */
  removeFromNewsletterMailinglist(newsletterMailinglistId: number, newsletterMailinglistName: string, index: number) {
    this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-danger';
    this.modalService.confirmDialogComponent.open(`<p>Remove from Newsletter Mailing List - <strong class='text-danger'>${newsletterMailinglistName}</strong></p>`).result.then(
      (result) => {
        this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-primary';
        if (result == 'confirmed') {
          this.newsletterMailinglistService
            .removeContact(newsletterMailinglistId, this.contactId)
            .then((response_json) => {
              if (response_json.success) {
                this.notyService.notify(response_json.text || response_json.result || 'Removed from newsletter mailing list', 'info', 5000, 'topRight');
                this.loadNewsletterMailinglists();
              } else this.notyService.notify(response_json.text || response_json.result || 'Error removing from newsletter mailing list', 'error', 5000, 'topRight');
            })
            .catch(() => {
              this.notyService.notify('Error removing from newsletter mailing list', 'error', 5000, 'topRight');
            });
        }
      },
      (reason) => {
        this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-primary';
      }
    );
  }
}
